import React from 'react';
import { connect } from 'react-redux';
import IconsDisabled from '../../design/socialControls/IconsDisabled';
import { abbreviatedNumber } from '../../design/utilities';
import { isLogged, socialIcons } from '../helpers';

const mapState = (state, ownProps) => ({
  poppinIcon: state.reading.showPoppins ? socialIcons.poppinOn : socialIcons.poppinOff,
  likeIcon: state.currentEpisode.liked ? socialIcons.liked : socialIcons.like,
  likesCount: state.currentEpisode.episode && abbreviatedNumber(state.currentEpisode.episode.public_stats.likes_count, 1),
  commentIcon: socialIcons.comment,
  commentsCount: state.currentEpisode.episode && abbreviatedNumber(state.currentEpisode.episode.public_stats.pop_comments_count, 1),
  shareIcon: socialIcons.share,
  reportIcon: socialIcons.report,
  isLogged: isLogged()
});

export default connect(mapState)(IconsDisabled);
